document.addEventListener('DOMContentLoaded', () => {
    const partnersucheForm = document.getElementById('partnersuche-form');

    if (partnersucheForm) {
        partnersucheForm.noValidate = true;
        const getLang = function () {
            return document.documentElement.lang || "de";
        }

        const validatePartnersucheform = function (e) {
            const partnersuchePlz = document.getElementById('Search_SingleSlotGeo').value;
            const partnersucheMode = document.getElementById('Mode').value;


            let msgPlz = 'Bitte geben Sie eine Postleitzahl an.';
            let msgMode = 'Bitte wählen Sie eine Dienstleistungskategorie aus.';


            if (getLang() === 'en') {
                msgPlz = 'Please enter a postal code.';
                msgMode = 'Please select a service category.';
            }

            let isValidPlz = partnersuchePlz ? true : msgPlz;
            let isValidMode = partnersucheMode ? true : msgMode;


            if (isValidPlz !== true || isValidMode !== true) {
                e.preventDefault();
                //Filtert den Array ob true oder Error-Meldung
                let errors = [isValidPlz, isValidMode].filter(msg => msg !== true);
                errors = errors.map(err => `<p>${err}</p>`).join("");
                document.getElementById("error-messages").innerHTML = errors;
            } else {
                document.getElementById("error-messages").innerHTML = '';
            }
        }

        //const emptyOption = document.getElementById('leerwert');

        partnersucheForm.addEventListener('submit', validatePartnersucheform);
    }
});